<template> 
  <v-app>
    <MenuHeader v-if="!$route.meta.hideHeaderFooter" />
    <v-main>
      <router-view />
    </v-main>
    <FooterWeb v-if="!$route.meta.hideHeaderFooter" />
  </v-app>
</template>


<script>
import MenuHeader from './components/MenuHeader.vue'
import FooterWeb from './views/FooterWeb.vue'
export default {
  name: 'App',
  components: {
    MenuHeader,
    FooterWeb
}
}

</script>
<style>
@media print {
  /* Escondemos elementos globales que no deben imprimirse */
  header, footer, .v-navigation-drawer, .v-bottom-navigation, .sidebar {
    display: none !important;
  }

  /* Reseteamos el contenedor de Vuetify para que fluya con el papel */
  .v-application {
    background: none !important;
  }
  .v-application__wrap {
    min-height: 100% !important;
    display: block !important;
  }
  .v-main {
    padding: 0 !important;
    display: block !important;
  }
  /* Aseguramos que el scroll no se bloquee al imprimir */
  html, body {
    overflow: visible !important;
    height: auto !important;
  }
}
</style>
